import React, {useState} from 'react';
import {Grid} from "@material-ui/core";
import testImage from "../../assets/images/test.webp";
import {APP_DOMAIN_PREFIX} from '../../environment';
import {ImagesCarousalModal} from '../../components'

function ImageSection(props) {

  const [modal, setModal] = useState(false);
  const {multiple = true} = props;

  let position = props.image?.search("userImages");
  let imageUrl = APP_DOMAIN_PREFIX + props.image;
  if (position == -1) {
    imageUrl = APP_DOMAIN_PREFIX + "/userImages/" + props.image;
  }

  return (
    <Grid item md={12} lg={12} className=' pr-30 cursor-pointer'>
      <Grid container>
        <Grid item className='main-img-container full-width'>
          <img src={props.image && imageUrl || testImage} alt='img' className='main-img'
               onClick={() => setModal(true)}/>

          {props.fullDetail && multiple&&
          <Grid container direction='row' justify={'space-between'} lg={12} style={{flexWrap: 'nowrap'}}
                className='mt-10 mb-20'>
            {props.multiImages && props.multiImages.map((item, index) => {
              let positions = item.picture?.search("userImages");
              let imageUrls = APP_DOMAIN_PREFIX + item.picture;
              if (positions == -1)
                imageUrls = APP_DOMAIN_PREFIX + "/userImages/" + item.picture;
              return (
                <Grid key={item + index} item lg={2} md={2} className='pl-10'>
                  <img src={item.picture && imageUrls || props.image} alt='img' className='related-img'/>
                </Grid>)
            })
            }
            <Grid item lg={2} md={2} className='pl-10'>
              <img src={props.image && imageUrl || testImage} alt='img' className='related-img'/>
            </Grid>
            <Grid item lg={2} md={2} className='pl-10'>
              <img src={props.image && imageUrl || testImage} alt='img' className='related-img'/>
            </Grid> <Grid item lg={2} md={2} className='pl-10'>
            <img src={props.image && imageUrl || testImage} alt='img' className='related-img'/>
          </Grid> <Grid item lg={2} md={2} className='pl-10'>
            <img src={props.image && imageUrl || testImage} alt='img' className='related-img'/>
          </Grid> <Grid item lg={2} md={2} className='pl-10'>
            <img src={props.image && imageUrl || testImage} alt='img' className='related-img'/>
          </Grid>
          </Grid>
          }
        </Grid>
      </Grid>
      <ImagesCarousalModal open={modal} setOpen={setModal}/>
    </Grid>
  );
}

export default ImageSection;
